import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './ItSkillForm.jsx'

export default createSubmit(name)